import "./Footer.css"

function Footer() {


    return (
      <footer className="footer-section">
        <div className="footer-container">
          <ul className="quick-links">
            <li>HOME</li>
            <li>PRODUCTS</li>
            <li>CONTACT US</li>
            <li>ABOUT</li>
          </ul>
          <span className="logo footer-logo"><span className="yellow-color">O</span>NES<span className="yellow-color">T</span>E<span className="yellow-color">P</span></span>
        </div>
        <span className="copy-right">Copyright © 2023 ONE STEP • ron.TheVeloper</span>
      </footer>
    );
  }
  
  export default Footer;